var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "tableBox" },
    [
      _c("div", { staticClass: "filter-list" }, [
        _c("div", { staticClass: "filter-item" }, [
          _c("div", { staticClass: "item-label" }, [
            _vm._v("\n        状态\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-component" }, [
            _c(
              "div",
              { staticClass: "el-select-wrapper" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "请选择", clearable: "" },
                    on: { change: _vm.buildData },
                    model: {
                      value: _vm.status.value,
                      callback: function($$v) {
                        _vm.$set(_vm.status, "value", $$v)
                      },
                      expression: "status.value"
                    }
                  },
                  _vm._l(_vm.status.options, function(item) {
                    return _c("el-option", {
                      key: item.code,
                      attrs: { label: item.name, value: item.code }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData } },
        [
          _c("el-table-column", {
            attrs: { type: "index", width: "20px", label: "#" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { property: "typeText", label: "类型", width: "80px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "summary",
              label: "主题",
              "min-width": "200px",
              "show-overflow-tooltip": false
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-link",
                      {
                        attrs: {
                          type: "primary",
                          underline: false,
                          target: "_blank",
                          href: _vm.$util.buildSmsActivityDetailUrl(
                            scope.row.actId
                          )
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.summary) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "description",
              label: "详情描述",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "eventTypeText",
              label: "事件类型",
              width: "120px",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "eventReasonText",
              label: "事件原因",
              width: "80px",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "eventLevelText",
              label: "严重等级",
              width: "80px",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "safetyMeasures",
              label: "安全措施",
              width: "80px",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "statusText",
              label: "状态",
              width: "65px",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "reportTime",
              label: "报告时间",
              width: "120px",
              "show-overflow-tooltip": true
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-wrapper" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "prev, pager, next",
              total: _vm.page.total,
              "current-page": _vm.page.num,
              "page-size": _vm.page.size
            },
            on: {
              "update:currentPage": function($event) {
                return _vm.$set(_vm.page, "num", $event)
              },
              "update:current-page": function($event) {
                return _vm.$set(_vm.page, "num", $event)
              },
              "update:pageSize": function($event) {
                return _vm.$set(_vm.page, "size", $event)
              },
              "update:page-size": function($event) {
                return _vm.$set(_vm.page, "size", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35446c38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35446c38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/achievement/result/SymptomDetail.vue
// module id = null
// module chunks = 